import { render, staticRenderFns } from "./recommendShop.vue?vue&type=template&id=405fd2b4&scoped=true&"
import script from "./recommendShop.vue?vue&type=script&lang=js&"
export * from "./recommendShop.vue?vue&type=script&lang=js&"
import style0 from "./recommendShop.vue?vue&type=style&index=0&id=405fd2b4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405fd2b4",
  null
  
)

export default component.exports